import { Chip, type ChipTone } from '@/shared/ui/chip'
import type { MeetingState } from '../model/schema'

const label: Record<MeetingState, string> = {
  scheduled: 'Запланирована',
  active: 'Идёт',
  ended: 'Завершена',
  cancelled: 'Отменена',
}

const tone: Record<MeetingState, ChipTone> = {
  scheduled: 'info',
  active: 'accent',
  ended: 'neutral',
  cancelled: 'warning',
}

export function MeetingStateBadge({
  state,
  className,
}: {
  state: MeetingState
  className?: string
}) {
  return (
    <Chip tone={tone[state]} {...(className ? { className } : {})}>
      {label[state]}
    </Chip>
  )
}
